<template>
  <div class="header-section">
      <img :src="images.home" class="banner">
      <img :src="images.logo" class="logo animate__animated animate__bounceInDown">
      <img :src="images.slogan01" class="slogan01 animate__animated animate__backInLeft">
      <img :src="images.slogan02" class="slogan02 animate__animated animate__backInRight">
      <img :src="images.homeIcon01" class="icon01 animate__animated animate__flipInX" @click="gotoSection(1)">
      <img :src="images.homeIcon02" class="icon02 animate__animated animate__flipInX" @click="gotoSection(2)">
      <img :src="images.homeIcon03" class="icon03 animate__animated animate__flipInX" @click="gotoSection(3)">
      <img :src="images.homeIcon04" class="icon04 animate__animated animate__flipInX" @click="gotoSection(4)">
      <img :src="images.homeIcon05" class="icon05 animate__animated animate__flipInX" @click="gotoSection(5)">
      <img :src="images.homeIcon06" class="icon06 animate__animated animate__flipInX" @click="gotoSection(6)">
  </div>
</template>

<script>
import images from '@/utils/images.js'
export default {
    data () {
        return {
            images: images
        }
    },
    methods: {
        gotoSection (index) {
            this.$emit('gotoSection', index)
        }
    }
}
</script>

<style lang="scss" scoped>
.header-section {
    font-size: 0;
    position: relative;
    padding-bottom: 20px;
    .banner {
        margin-bottom: 16px;
    }
    .logo {
        position: absolute;
        width: 100%;
        left: 0;
    }
    .slogan01 {
        position: absolute;
        left: 0;
        top: 100px;
    }
    .slogan02 {
        position: absolute;
        left: 0;
        top: 100px;
    }
    .icon01, .icon02, .icon03, .icon04, .icon05, .icon06 {
        width: 375px;
    }
}
</style>